export default __webpack_public_path__ + "static/media/logo_on-dark.51d206a1.svg";